var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-qrcode"},[_c('canvas',{attrs:{"id":"productQrcode","width":"85","height":"85"}}),_c('p',{style:({ color: _vm.textColor })},[_vm._v("微信扫码查看")])])
}
var staticRenderFns = []

export { render, staticRenderFns }